import { FontAwesome5 } from '@expo/vector-icons';
import {
  HRStatisticsOfActivities,
  HRStatisticsOfActivitiesProps,
  useHRPortalTranslation,
  SectionPlaceholder,
  HRText,
} from '@openeducation/hr-rn-components';
import { styled } from '@openeducation/hr-rn-themes';
import React, { memo } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import ActivitiesBarChartWeb from '../charts/activities-bar-chart.web';

interface StatisticsOfActivitiesProps {
  statisticsOfActivitiesProps: Omit<HRStatisticsOfActivitiesProps, 'children'>;
  activitiesChartData: number[];
  chartBarsColor: string;
  scalesHeight: number;
  style?: StyleProp<ViewStyle>;
  onGroupClassAttendancePress?: () => void;
  isGroupClassAttendanceEnabled?: boolean;
}

const StatisticsOfActivities = ({
  statisticsOfActivitiesProps,
  activitiesChartData,
  chartBarsColor,
  scalesHeight,
  style,
  onGroupClassAttendancePress,
  isGroupClassAttendanceEnabled,
}: StatisticsOfActivitiesProps) => {
  const { t } = useHRPortalTranslation();
  const noData = activitiesChartData.every((item) => item === 0);

  return (
    <HRStatisticsOfActivities {...statisticsOfActivitiesProps} style={style}>
      {isGroupClassAttendanceEnabled && (
        <AttendanceButton onPress={onGroupClassAttendancePress}>
          <AttendanceButtonIcon />
          <AttendanceButtonText>
            {t('groupAttendance.openModal')}
          </AttendanceButtonText>
        </AttendanceButton>
      )}

      {noData ? (
        <SectionPlaceholder text={t('home.statisticsOfActivities.empty')} />
      ) : (
        <ActivitiesBarChartWeb
          data={activitiesChartData}
          barsColor={chartBarsColor}
          scalesHeight={scalesHeight}
        />
      )}
    </HRStatisticsOfActivities>
  );
};

export default memo(StatisticsOfActivities);

const AttendanceButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  align-self: flex-end;
  position: absolute;
  inset-inline-end: 30px;
  z-index: 10;
`;

export const AttendanceButtonText = styled(HRText).attrs(({ theme }) => ({
  fontSize: 16,
  fontType: 'medium',
  color: theme.color.primary,
}))`
  margin-inline-start: 10px;
`;

export const AttendanceButtonIcon = styled(FontAwesome5).attrs(({ theme }) => ({
  color: theme.color.primary,
  size: 16,
  name: 'upload',
}))``;
